export const SITE_CONTACTS = {
    companyName: 'M.SOLUTIONS SRL',
    email: 'info@easy-funeral.it',
    address: 'Via collecedro 1, Cervaro (FR) 03044',
    vatNumber: '03353530607',
    shareCapital: '10.000 €',
    businessRegister: process.env.REACT_APP_COMPANY_BUSINESS_REGISTER?.trim() || '',
    rea: process.env.REACT_APP_COMPANY_REA?.trim() || '',
    pec: process.env.REACT_APP_COMPANY_PEC?.trim() || '',
    capitalPaidStatus: process.env.REACT_APP_COMPANY_CAPITAL_PAID_STATUS?.trim() || '',
};
